import { Slider } from 'element-ui'

const YSlider = Slider
YSlider.$depends = [Slider]
YSlider.$name = 'y-slider'
YSlider._name = 'Slider 滑块'

export default YSlider
